export default class MyPortfolioCtrl {

	constructor($scope, $stateParams, $timeout, GlobalSrv, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService, $interval) {
		// constants
		var config = require('../../../../../local.env.json')
		let staticServerurl = config.STATIC_IMAGE_URL
		var portfolioVm = this

		portfolioVm.actualStatement = {}
		portfolioVm.actualStatement.blogDescription = ''
		var currentUser = ($cookies.get('currentUser')) ? JSON.parse($cookies.get('currentUser')) : null
		portfolioVm.years = []
		portfolioVm.evidences = []
		portfolioVm.reflections = []
		portfolioVm.filetypes = GlobalConfig.portfolioConfig.fileTypes

		portfolioVm.comments = []

		var SEARCH_PARAMS = {}
		const haveGuest = $stateParams.haveGuest
		const isOnEvaluation = $stateParams.isOnEvaluation
		const isExternal = $stateParams.isExternal

		portfolioVm.haveGuest = false
		portfolioVm.isOnEvaluation = (isOnEvaluation ? true : false)
		portfolioVm.isExternal = (isExternal ? true : false)

		portfolioVm.mathId = Math.random()

		$interval(function (e) {
			portfolioVm.mathId = Math.random()
		}, 2000)

		//console.log($stateParams)
		if (haveGuest) {
			if (isExternal) {
				SEARCH_PARAMS.guestUser = parseInt($stateParams.ownerPortfolio)
				SEARCH_PARAMS.userId = SEARCH_PARAMS.guestUser
			} else {
				SEARCH_PARAMS.guestUser = (currentUser) ? currentUser.id : null
				SEARCH_PARAMS.userId = $cookies.get('ownerPortfolio')
			}

			portfolioVm.haveGuest = true
			portfolioVm.mainText = (portfolioVm.isOnEvaluation ? 'Evaluar Portafolio' : 'Otros Portafolios')
		} else {
			SEARCH_PARAMS.userId = (currentUser) ? currentUser.id : null
			SEARCH_PARAMS.guestUser = SEARCH_PARAMS.userId
			portfolioVm.haveGuest = false
			portfolioVm.mainText = 'Mi Portafolio'
		}

		portfolioVm.selectedYear = moment().year()
		portfolioVm.evaluator = {}

		portfolioVm.selectedReflection = {}
		portfolioVm.selectedOrderReflection = ''
		portfolioVm.filtersOrderReflections = [
			{ filterId: '', filterName: ' ' },
			{ filterId: 'blogTitle', filterName: 'Título Ascendiente' },
			{ filterId: '-blogTitle', filterName: 'Título Descendiente' },
			{ filterId: 'blogUpdatedDate', filterName: 'Fecha Ascendiente' },
			{ filterId: '-blogUpdatedDate', filterName: 'Fecha Descendiente' },
		]

		portfolioVm.selectedIsEnlightedFilter = ''
		portfolioVm.isEnlightedFilter = [
			{ filterId: '', filterName: ' ' },
			{ filterId: 1, filterName: 'Destacadas' },
			{ filterId: 0, filterName: 'No Destacadas' },
		]

		portfolioVm.selectedFilterEvidence = ''
		portfolioVm.filtersEvidences = [
			{ filterId: '', filterName: ' ' },
			{ filterId: portfolioVm.filetypes.image, filterName: 'Imagenes' },
			{ filterId: portfolioVm.filetypes.video, filterName: 'Videos' },
			{ filterId: portfolioVm.filetypes.audio, filterName: 'Audios' },
			{ filterId: portfolioVm.filetypes.document, filterName: 'Documentos' },
		]

		portfolioVm.selectedOrderEvidence = ''
		portfolioVm.filtersOrderEvidences = [
			{ filterId: '', filterName: ' ' },
			{ filterId: 'blogTitle', filterName: 'Título Ascendiente' },
			{ filterId: '-blogTitle', filterName: 'Título Descendiente' },
			{ filterId: 'blogUpdatedDate', filterName: 'Fecha Ascendiente' },
			{ filterId: '-blogUpdatedDate', filterName: 'Fecha Descendiente' },
		]

		portfolioVm.addUserComment = addUserComment
		portfolioVm.addReflectionComment = addReflectionComment
		portfolioVm.addNewRegistry = addNewRegistry
		portfolioVm.setEnlighted = setEnlighted
		portfolioVm.setInput = setInput
		portfolioVm.evidenceLinks = evidenceLinks
		portfolioVm.disableEvidence = disableEvidence
		portfolioVm.editEvidence = editEvidence
		portfolioVm.editStatement = editStatement
		portfolioVm.historyStatement = historyStatement
		portfolioVm.getPortfolioBasics = getPortfolioBasics
		portfolioVm.commentDetails = commentDetails
		portfolioVm.evalComment = evalComment
		portfolioVm.editReflection = editReflection
		portfolioVm.deleteReflection = deleteReflection

		$scope.notPicture = require('../../../../images/unknown.png')

		//initial functions

		function activate() {
			portfolioVm.getPortfolioBasics()
			getPortfolioComitee()
		}

		function getYears(actualYear, initialYear) {
			const time = (actualYear - initialYear) + 1

			var array = []

			for (var i = 0; i < time; i++) {
				array.push(actualYear - i)
			}

			return array
		}

		$scope.onUserPictureError = function(callback) {
			$scope.picture = $scope.notPicture

			if ($scope.rut) {
				GlobalSrv.getUserImage.get({ identification: $scope.rut }).$promise.then((response) => {
					$scope.pictureRosario = response.profilePicture + '?1=' + $scope.mathRandom
					callback && callback()
				})
			} else {
				callback && callback()
			}
		}

		activate()
		//methods
		function getPortfolioBasics() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			$scope.mathRandom = Math.random()
			$scope.picture = $scope.notPicture

			if (!haveGuest) {
				$scope.rut = (currentUser && currentUser.dsIdentification) ? currentUser.dsIdentification : ''

				if (currentUser && currentUser.pictureExtension) {
					$scope.picture = staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + $scope.mathRandom
				} else if (currentUser && currentUser.pictureRosario) {
					$scope.picture = currentUser.pictureRosario
				} else {
					$scope.onUserPictureError()
				}
			}

			PortfolioSrv.getPortfolioBasics.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.profesor = dataReturn.profesorData || {}

					if(!portfolioVm.years.length){
						portfolioVm.years = getYears(portfolioVm.selectedYear, portfolioVm.profesor.initialYear || 2017 )
					}


					if (haveGuest) {
						$scope.rut = portfolioVm.profesor.identification
						$scope.picture = staticServerurl + '/profilepicture/' + portfolioVm.profesor.pictureExtension + '?1=' + $scope.mathRandom
					}

					portfolioVm.profesor.lastUpdate = moment(portfolioVm.profesor.lastUpdate).format('DD/MM/YYYY')
					portfolioVm.statements = dataReturn.statementsData

					if (portfolioVm.statements.length > 0) {
						for (var i = portfolioVm.statements.length - 1; i >= 0; i--) {
							portfolioVm.statements[i].blogDescription = portfolioVm.statements[i].blogDescription.replaceAll('>?', '>')
						}
						portfolioVm.actualStatement = portfolioVm.statements[0]
					} else {
						portfolioVm.actualStatement = {}
					}

					portfolioVm.evidences = dataReturn.evidencesData
					portfolioVm.reflections = dataReturn.reflectionsData
					portfolioVm.commentsUsers = dataReturn.commentsData.commentsUsers
					portfolioVm.commentsEvals = dataReturn.commentsData.commentsEvals
					for (let r in portfolioVm.reflections) {
						portfolioVm.reflections[r].current = moment(portfolioVm.reflections[r].blogCreationDate,'DD/MM/YYYY').isSame(new Date(), 'year')
					}
				}
			}, function (data) {
				console.log(data)
			})
		}

		function getPortfolioComitee() {
			if (portfolioVm.isOnEvaluation) {
				let header = {
					userId: SEARCH_PARAMS.guestUser,
				}

				PortfolioSrv.getPortfolioComitee.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						portfolioVm.evaluator = dataReturn.data
					}
				}, function (data) {
					console.log(data)
				})
			}
		}

		function setEnlighted(reflection) {
			if (!portfolioVm.isOnEvaluation && !portfolioVm.haveGuest) {
				var previous = reflection.blogIsEnlighted

				if (previous == 0) {
					reflection.blogIsEnlighted = 1
				} else {
					reflection.blogIsEnlighted = 0
				}

				let header = {
					reflectionId: reflection.blogId,
					isEnlighted : reflection.blogIsEnlighted,
				}

				PortfolioSrv.setEnlighted.update(header).$promise.then(function (dataReturn) {
					if (!dataReturn.status) {
						reflection.blogIsEnlighted = previous
					}
				}, function (data) {
					console.log(data)
				})
			}
		}

		function setInput(reflection) {
			var previous = reflection.blogIsInput

			if (previous == 0) {
				reflection.blogIsInput = 1
			} else {
				reflection.blogIsInput = 0
			}

			let header = {
				reflectionId: reflection.blogId,
				isInput     : reflection.blogIsInput,
			}

			PortfolioSrv.setInput.update(header).$promise.then(function (dataReturn) {
				if (!dataReturn.status) {
					reflection.isInput = previous
				}
			}, function (data) {
				console.log(data)
			})
		}

		function updateUsersComments() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioSrv.getCommentsUsers.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.commentsUsers = dataReturn.data
				}
			}, function (data) {
				console.log(data)
			})
		}

		function updateEvalsComments() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioSrv.getCommentsEvals.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.commentsEvals = dataReturn.data
				}
			}, function (data) {
				console.log(data)
			})
		}

		function getEvidences() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.evidences = dataReturn.data
				}
			}, function (data) {
				console.log(data)
			})
		}

		function getStatements() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioSrv.getStatements.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.statements = dataReturn.data

					if (portfolioVm.statements.length > 0) {
						for (var i = portfolioVm.statements.length - 1; i >= 0; i--) {
							portfolioVm.statements[i].blogDescription = portfolioVm.statements[i].blogDescription.replaceAll('>?', '>')
						}
						portfolioVm.actualStatement = portfolioVm.statements[0]
					} else {
						portfolioVm.actualStatement = {}
					}
				}
			}, function (data) {
				console.log(data)
			})
		}

		function getReflections() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioSrv.getReflections.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.reflections = dataReturn.data
					for (let r in portfolioVm.reflections) {
						portfolioVm.reflections[r].current = moment(portfolioVm.reflections[r].blogCreationDate, 'DD/MM/YYYY').isSame(new Date(), 'year')
					}
				}
			}, function (data) {
				console.log(data)
			})
		}

		function updateReflectionComments(reflection) {
			let header = {
				reflectionId: reflection.blogId,
			}

			PortfolioSrv.getReflectionCommentById.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					reflection.comments = dataReturn.data
					reflection.totalComments = reflection.comments.length
				}
			}, function (data) {
				console.log(data)
			})
		}

		// modals
		function addUserComment() {
			let header = SEARCH_PARAMS

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.addUserComment().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					updateUsersComments()
				}
			})
		}

		function addReflectionComment(reflection) {
			let header = {
				guestUser : SEARCH_PARAMS.guestUser,
				reflection: reflection,
				isExternal: isExternal,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.addReflectionComment().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					updateReflectionComments(reflection)
				}
			})
		}

		function addNewRegistry() {
			let header = {
				userId   : SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate  : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.addNewRegistry().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					activate()
				}
			})
		}

		function evidenceLinks(evidence) {
			let header = {
				evidence: evidence,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.evidenceLinks().then((promise) => {
			})
		}

		function disableEvidence(evidence) {
			let header = {
				evidence: evidence,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.disableEvidence().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					getEvidences()
				}
			})
		}

		function editEvidence(evidence) {
			let header = {
				evidence: evidence,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.editEvidence().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					getEvidences()
				}
			})
		}

		function editStatement(statement) {
			let header = {
				userId   : SEARCH_PARAMS.guestUser,
				statement: statement,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.editStatement().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					getStatements()
				}
			})
		}

		function historyStatement() {
			let header = {
				statements: portfolioVm.statements,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.historyStatement().then((promise) => {
			})
		}

		function commentDetails(comment) {
			let header = {
				comment: comment,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.commentDetails().then((promise) => {
			})
		}

		function evalComment() {
			let header = {
				comment       : null,
				guestUser     : SEARCH_PARAMS.guestUser,
				userId        : SEARCH_PARAMS.userId,
				isOnEvaluation: portfolioVm.isOnEvaluation,
				startDate     : moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate       : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
				evaluator     : portfolioVm.evaluator,
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.commentDetails().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					updateEvalsComments()
				}
			})
		}

		function editReflection(reflection) {
			let header = {
				reflection: reflection,
				userId    : SEARCH_PARAMS.userId,
				startDate : moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate   : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.editReflection().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					getReflections()
					getEvidences()
				}
			})
		}
		
		function deleteReflection(reflection) {
			let header = {
				reflection: reflection,
				userId    : SEARCH_PARAMS.userId,
				startDate : moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate   : moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
			}

			PortfolioModalSrv.setVariable(header)
			PortfolioModalSrv.deleteReflection().then((promise) => {
				let shared = PortfolioModalSrv.getVariable()

				if (shared.status) {
					getReflections()
					getEvidences()
				}
			})
		}

		String.prototype.replaceAll = function (searchStr, replaceStr) {
			var str = this

			if (str.indexOf(searchStr) === -1)
				return str

			return (str.replace(searchStr, replaceStr)).replaceAll(searchStr, replaceStr)
		}
	}

}

MyPortfolioCtrl.$inject = [ '$scope', '$stateParams', '$timeout', 'GlobalSrv', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state', 'ngYoutubeEmbedService', '$interval' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/myPortfolioCtrl.js